import { TextField, Typography, InputAdornment, IconButton } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import SunEditor, { buttonList } from "suneditor-react";
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File
import api from '../api';
import icLocation from '../../assets/ic_location.png';
import ImageUploader from 'react-images-upload';
import { format } from 'date-fns';
import CustomDate from '../components/customDate';
import CustomTextField from '../components/customTextField';
import { TimePicker, KeyboardDateTimePicker, KeyboardDatePicker, MuiPickersUtilsProvider, KeyboardTimePicker } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import Map from '../components/Map';
import { LoadScript } from "@react-google-maps/api";
import NumberFormat from 'react-number-format';
import Constant from '../../library/Constant';
import { Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const lib = ["places"];

function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator
            isNumericString
            prefix="Rp. "
        />
    );
}


export default function AddEmergency(props) {

    const history = useHistory()
    // const [tglOrder, setTglOrder] = useState(new Date());
    const [tglBooking, setTglBooking] = useState(new Date());
    const [jamBooking, setJamBooking] = useState(new Date());
    const [title, setTitle] = useState("")
    const [distance, setDistance] = useState("")
    const [pemesan, setPemesan] = useState("")
    const [noHP, setNoHP] = useState("")
    const [pasien, setPasien] = useState("")
    const [unitClass, setUnitClass] = useState("")
    const [noRM, setNoRM] = useState("")
    const listKategori = [
        { value: 'Umum', id: 1 },
        { value: 'Psichiatry', id: 2 },
        { value: 'Isolasi', id: 3 },
    ]
    const [kategori, setKategori] = useState(listKategori[0])

    // const listOrderType = [
    //     { value: 'Saat Ini', id: 1 },
    //     { value: 'Untuk Nanti', id: 2 },
    // ]
    // const [orderType, setOrderType] = useState(null)

    const listJenis = [
        { value: 'Booking', id: 1 },
        { value: 'Maintenance', id: 2 },
    ]
    const [jenis, setJenis] = useState(listJenis[0])

    const listMobil = [
        { value: 'porsche - B 1234 RI', id: 3 },
        { value: 'range rover - F 1234 XYZ', id: 1 },
        { value: 'ferrari - B 4321 EF', id: 0 },
    ]
    const [mobil, setMobil] = useState(null)

    const [perawat, setPerawat] = useState([])
    const [dataPerawat, setDataPerawat] = useState([])

    const [dataSupir, setDataSupir] = useState([])
    const [supir, setSupir] = useState(null)

    const [dokter, setDokter] = useState([])
    const [dataDokter, setDataDokter] = useState([])

    const [dataAmbulance, setDataAmbulance] = useState([])
    const [ambulance, setAmbulance] = useState(null)

    const [price, setPrice] = useState("")
    const [notes, setNotes] = useState("")
    const [ketAlamat, setKetAlamat] = useState("")

    const [errorTitle, setErrorTitle] = React.useState(false);
    const [errorPemesan, setErrorPemesan] = React.useState(false);
    const [errorPasien, setErrorPasien] = React.useState(false);
    const [errorHP, setErrorHP] = React.useState(false)
    const [errorJamBerangkat, setErrorJamBerangkat] = React.useState(false)
    const [errorJamPulang, setErrorJamPulang] = React.useState(false)
    const [errorAlamat, setErrorAlamat] = React.useState(false)
    const [errorPesanan, setErrorPesanan] = React.useState(false)
    const [errorJamBooking, setErrorJamBooking] = React.useState(false)
    const [errorPerawat, setErrorPerawat] = React.useState(false)
    const [errorSupir, setErrorSupir] = React.useState(false)
    const [errorDokter, setErrorDokter] = React.useState(false)

    const [texterrorTitle, setTextErrorTitle] = React.useState(null);
    const [texterrorPemesan, setTextErrorPemesan] = React.useState(null);
    const [texterrorPasien, setTextErrorPasien] = React.useState(null);
    const [texterrorHP, setTextErrorHP] = React.useState(null)
    const [texterrorJamBerangkat, setTextErrorJamBerangkat] = React.useState(null)
    const [texterrorJamPulang, setTextErrorJamPulang] = React.useState(null)
    const [texterrorAlamat, setTextErrorAlamat] = React.useState(null)
    const [texterrorPesanan, setTextErrorPesanan] = React.useState(null)
    const [texterrorJamBooking, setTextErrorJamBooking] = React.useState(null)
    const [texterrorPerawat, setTextErrorPerawat] = React.useState(null)
    const [texterrorSupir, setTextErrorSupir] = React.useState(null)
    const [texterrorDokter, setTextErrorDokter] = React.useState(null)


    const [selectedTime, handleTimeChange] = useState(null);
    const [jamBerangkat, setJamBerangkat] = useState(null);
    const [jamPulang, setJamPulang] = useState(null);
    const [berangkatActual, setBerangkatActual] = useState(null);
    const [pulangActual, setPulangActual] = useState(null);
    const [visibleMap, setvisibleMap] = React.useState(false);
    const [saveDataMap, setSaveDataMap] = React.useState(null);
    const [messageAlert, setMessageAlert] = useState("")
    const [statusAlert, setStatusAlert] = useState("")
    const [openAlert, setOpenAlert] = useState(false);

    const handleSeparator = (string) => {
        let val = string.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return val
    }

    const forceUpdate = React.useReducer(bool => !bool)[1];

    useEffect(() => {
        getAmbulance()
        getListPetugas()
        getDokter()
    }, []);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false)
    }

    const getAmbulance = () => {
        api.create().getAmbulance().then(response => {
            console.log(response);
            if (response.data) {
                let dataAmbulance = []
                response.data.data.map(item => {
                    dataAmbulance.push({
                        id: item.id,
                        value: `${item.vehicle_name} - ${item.vehicle_number}`
                    })
                })
                setDataAmbulance(dataAmbulance)
            }
        })
    }

    const getDokter = () => {
        api.create().getListDokter().then(response => {
            console.log(response);
            if (response.data) {
                let dataDokter = []
                response.data.data.map(item => {
                    if (item.deleted_at === null) {
                        if (item.is_igd === 1) {
                            dataDokter.push({
                                id: item.id,
                                value: item.name
                            })
                        }
                    }
                })
                setDataDokter(dataDokter)
            }
        })
    }

    const getListPetugas = () => {
        api.create().getListPetugas().then(response => {
            console.log(response);
            if (response.data) {
                let dataSupir = []
                let dataPerawat = []
                response.data.data.map(item => {
                    if (item.deleted_at === null) {
                        if (item.role === "Supir") {
                            dataSupir.push({
                                id: item.id,
                                value: item.name
                            })
                        } else if (item.role === "Perawat") {
                            dataPerawat.push({
                                id: item.id,
                                value: item.name
                            })
                        }
                    }
                })
                setDataSupir(dataSupir)
                setDataPerawat(dataPerawat)
            }
        })
    }

    const handleSave = () => {
        if (pemesan === "") {
            setErrorPemesan(true)
            setTextErrorPemesan("Nama Pemesan wajib diisi")
        } else if (noHP === "") {
            setErrorHP(true)
            setTextErrorHP("No Handphone wajib diisi")
        } else if (pasien === "") {
            setErrorPasien(true)
            setTextErrorPasien("Nama Pasien wajib diisi")
        } else if (kategori === null) {
            setErrorPesanan(true)
            setTextErrorPesanan("Kategori Pesanan wajib diisi")
        } else if (saveDataMap === null) {
            setErrorAlamat(true)
            setTextErrorAlamat("Alamat Pesanan wajib diisi")
        } else if (jamBooking !== null && (format(new Date(), 'yyyyMMdd') === (format(new Date(tglBooking), 'yyyyMMdd'))) && (format(new Date(), 'HHmmss') > format(new Date(jamBooking), 'HHmmss'))) {
            setErrorJamBooking(true)
            setTextErrorJamBooking("Jam Pesanan wajib lebih dari jam saat ini")
        } else if (ambulance !== null) {
            if (jamBerangkat === null) {
                setErrorJamBerangkat(true)
                setTextErrorJamBerangkat("Perkiraan Jam Berangkat wajib diisi")
            } else if (jamPulang === null) {
                setErrorJamPulang(true)
                setTextErrorJamPulang("Perkiraan Jam Pulang wajib diisi")
            } 
            // else if (perawat.length < 1 && supir === null) {
            //     setErrorPerawat(true)
            //     setErrorSupir(true)
            //     setTextErrorPerawat("Perawat wajib diisi")
            //     setTextErrorSupir("Supir wajib diisi")
            // } else if (dokter.length < 1) {
            //     setErrorDokter(true)
            //     setTextErrorDokter("Dokter wajib diisi")
            // }
             else {
                let nurse = []
                if (perawat.length > 0) {
                    perawat.map(item => {
                        nurse.push(item.id)
                    })
                }
                let doctor = []
                if (dokter.length > 0) {
                    dokter.map(item => {
                        doctor.push(item.id)
                    })
                }
                let payload = {
                    "ambulance_id": ambulance === null ? null : ambulance.id,
                    "customer_name": pemesan,
                    "phone_number": noHP,
                    "patient_name": pasien,
                    "medical_record_no": noRM,
                    "booking_date": format(new Date(tglBooking), 'yyyy-MM-dd'),
                    "booking_time": format(new Date(jamBooking), 'HH:mm:ss'),
                    "order_category": kategori.id,
                    "address": saveDataMap === null ? '' : saveDataMap.address,
                    "latitude": saveDataMap === null ? '' : saveDataMap.lat,
                    "longitude": saveDataMap === null ? '' : saveDataMap.lng,
                    "estimated_mileage": saveDataMap === null ? '' : Number(Number(saveDataMap.distance) / 1000).toFixed(1),
                    "order_type": jenis === null ? null : jenis.id,
                    "class_unit": unitClass,
                    "estimated_departure_time": jamBerangkat === null ? null : format(new Date(jamBerangkat), 'HH:mm:ss'),
                    "estimated_return_time": jamPulang === null ? null : format(new Date(jamPulang), 'HH:mm:ss'),
                    "actual_departure_time": berangkatActual === null ? null : format(new Date(berangkatActual), 'HH:mm:ss'),
                    "actual_return_time": pulangActual === null ? null : format(new Date(pulangActual), 'HH:mm:ss'),
                    "estimated_price": price === null ? 0 : price === "" ? 0 : price,
                    "is_admin": 1,
                    "notes": notes,
                    "address_notes": ketAlamat,
                    "nurse_emergency_user_id": nurse,
                    "driver_emergency_user_id": supir && supir.id,
                    "doctor_id": doctor
                }
                console.log(JSON.stringify(payload));
                console.log(payload);
                api.create().createOrder(payload).then(response => {
                    console.log(response);
                    if (response.data) {
                        if (response.data.status === true) {
                            history.goBack()
                        } else {
                            if (response.data.data) {
                                setMessageAlert(response.data.data)
                                setStatusAlert('warning')
                                setOpenAlert(true)
                            }
                        }
                    }
                })
            }
        } else {
            let nurse = []
            if (perawat.length > 0) {
                perawat.map(item => {
                    nurse.push(item.id)
                })
            }
            let doctor = []
            if (dokter.length > 0) {
                dokter.map(item => {
                    doctor.push(item.id)
                })
            }
            let payload = {
                "ambulance_id": ambulance === null ? null : ambulance.id,
                "customer_name": pemesan,
                "phone_number": noHP,
                "patient_name": pasien,
                "medical_record_no": noRM,
                "booking_date": format(new Date(tglBooking), 'yyyy-MM-dd'),
                "booking_time": format(new Date(jamBooking), 'HH:mm:ss'),
                "order_category": kategori.id,
                "address": saveDataMap === null ? '' : saveDataMap.address,
                "latitude": saveDataMap === null ? '' : saveDataMap.lat,
                "longitude": saveDataMap === null ? '' : saveDataMap.lng,
                "estimated_mileage": saveDataMap === null ? '' : Number(Number(saveDataMap.distance) / 1000).toFixed(1),
                "order_type": jenis === null ? null : jenis.id,
                "class_unit": unitClass,
                "estimated_departure_time": jamBerangkat === null ? null : format(new Date(jamBerangkat), 'HH:mm:ss'),
                "estimated_return_time": jamPulang === null ? null : format(new Date(jamPulang), 'HH:mm:ss'),
                "actual_departure_time": berangkatActual === null ? null : format(new Date(berangkatActual), 'HH:mm:ss'),
                "actual_return_time": pulangActual === null ? null : format(new Date(pulangActual), 'HH:mm:ss'),
                "estimated_price": price === null ? 0 : price === "" ? 0 : price,
                "is_admin": 1,
                "notes": notes,
                "address_notes": ketAlamat,
                "nurse_emergency_user_id": nurse,
                "driver_emergency_user_id": supir && supir.id,
                "doctor_id": doctor
            }
            console.log(JSON.stringify(payload));
            console.log(payload);

            api.create().createOrder(payload).then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data.status === true) {
                        history.goBack()
                    } else {
                        if (response.data.data) {
                            setMessageAlert(response.data.data)
                            setStatusAlert('warning')
                            setOpenAlert(true)
                        }
                    }
                }
            })
        }

    }

    return (
        <div style={{ maxHeight: props.height - 80, width: '100%', overflow: 'scroll', padding: '20px 0px' }}>
            <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ width: '100%' }}>
                    <Typography style={{ color: 'black', fontWeight: '500', fontFamily: 'Poppins' }}>Data Pemesan</Typography>
                    <div className="grid grid-2x gap-20px" style={{ padding: 20, paddingRight: 40, paddingLeft: 40 }}>
                        <div className="column-1" style={{ width: '90%' }}>
                            <div>
                                <CustomTextField
                                    required={true}
                                    label="Nama Pemesan"
                                    error={errorPemesan}
                                    helperText={texterrorPemesan}
                                    onChange={(val) => {
                                        setPemesan(val)
                                        setErrorPemesan(false)
                                        setTextErrorPemesan("")
                                        forceUpdate()
                                    }}
                                />
                            </div>
                        </div>
                        <div className="column-2">
                            <div>
                                <TextField
                                    style={{ width: '90%' }}
                                    id="noHp"
                                    name="noHp"
                                    label="No. Handphone"
                                    required={true}
                                    error={errorHP}
                                    helperText={texterrorHP}
                                    value={noHP || ""}
                                    // placeholder={"input No hp pasien"}
                                    onChange={(e) => {
                                        setNoHP(e.target.value)
                                        setErrorHP(false)
                                        setTextErrorHP(null)
                                        forceUpdate()
                                    }}
                                    inputProps={{
                                        style: {
                                            fontSize: 14,
                                        }
                                    }}
                                    InputProps={{
                                        maxLength: 12,
                                        startAdornment: <InputAdornment position="start" style={{ margin: 0, marginRight: 5, fontSize: 14, }}>+62</InputAdornment>,
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 16,
                                            color: '#7e8085',
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        <div className="column-1" style={{ width: '90%' }}>
                            <div>
                                <CustomTextField
                                    required={true}
                                    label="Nama Pasien"
                                    error={errorPasien}
                                    helperText={texterrorPasien}
                                    onChange={(val) => {
                                        setPasien(val)
                                        setErrorPasien(false)
                                        setTextErrorPasien("")
                                        forceUpdate()
                                    }}
                                />
                            </div>
                        </div>
                        <div className="column-2" style={{ width: '90%' }}>
                            <div>
                                <CustomTextField
                                    label="No RM"
                                    onChange={(val) => {
                                        setNoRM(val)
                                        forceUpdate()
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <Typography style={{ color: 'black', fontWeight: '500', marginTop: 15, fontFamily: 'Poppins' }}>Detail Pesanan</Typography>
                    <div className="grid grid-2x gap-20px" style={{ padding: 20, paddingRight: 40, paddingLeft: 40 }}>
                        <div className="column-1" style={{ width: '90%' }}>
                            <div>
                                <Autocomplete
                                    options={listKategori}
                                    getOptionLabel={(option) => option.value}
                                    disableClearable
                                    style={{ width: '100%' }}
                                    onChange={(event, newInputValue) => {
                                        setKategori(newInputValue)
                                        setErrorPesanan(false)
                                        setTextErrorPesanan("")
                                        forceUpdate()
                                    }}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            required
                                            InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                            InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                            error={errorPesanan}
                                            helperText={texterrorPesanan}
                                            label={'Kategori Pesanan'}
                                        />
                                    }
                                    value={kategori}
                                />
                            </div>
                        </div>
                        <div className="column-2" style={{ width: '90%' }}>
                            <div>
                                <CustomTextField
                                    label="Alamat Pesanan"
                                    required={true}
                                    error={errorAlamat}
                                    helperText={texterrorAlamat}
                                    value={saveDataMap !== null ? saveDataMap.address : ''}
                                    onClick={() => setvisibleMap(true)}
                                    InputProps={{
                                        readOnly: true,
                                        style: {
                                            color: '#347AF0'
                                        },
                                        startAdornment: <InputAdornment position="start">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                // onClick={() => setvisibleMap(true)}
                                                edge="start"
                                            >
                                                <img src={icLocation} style={{ width: 20, height: 20 }} />
                                            </IconButton>
                                        </InputAdornment>,
                                    }}
                                />
                            </div>

                        </div>

                        <div className="column-1" style={{ width: '90%' }}>
                            <div>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        margin="normal"
                                        id="tanggal"
                                        label="Tanggal Pesanan"
                                        required={true} r
                                        format="dd/MM/yyyy"
                                        value={tglBooking}
                                        minDate={new Date()}
                                        onChange={(date) => {
                                            setTglBooking(date)
                                            forceUpdate()
                                        }}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        style={{ width: '100%', margin: 0 }}
                                    />
                                </MuiPickersUtilsProvider>
                            </div>
                        </div>

                        <div className="column-2" style={{ width: '90%' }}>
                            <div>
                                <CustomTextField
                                    label="Perkiraan KM"
                                    disabled={true}
                                    value={saveDataMap !== null ? saveDataMap.jarak : ''}
                                    onChange={(val) => {
                                        setDistance(val)
                                        forceUpdate()
                                    }}
                                />
                            </div>
                        </div>

                        <div className="column-1" style={{ width: '90%' }}>
                            <div>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardTimePicker
                                        error={errorJamBooking}
                                        helperText={texterrorJamBooking}
                                        ampm={false}
                                        id={"JamPesanan"}
                                        clearLabel
                                        minDate={new Date()}
                                        label="Jam Pesanan"
                                        value={jamBooking}
                                        onChange={(date) => {
                                            setJamBooking(date)
                                            setErrorJamBooking(false)
                                            setTextErrorJamBooking("")
                                            forceUpdate()
                                        }}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change time',
                                        }}
                                        style={{ width: '100%' }}
                                    />
                                </MuiPickersUtilsProvider>
                            </div>
                        </div>

                        <div className="column-2" style={{ width: '90%' }}>
                            <div>
                                <CustomTextField
                                    label="Keterangan Alamat"
                                    multiline
                                    onChange={(val) => {
                                        setKetAlamat(val)
                                        forceUpdate()
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <Typography style={{ color: 'black', fontWeight: '500', marginTop: 15, fontFamily: 'Poppins' }}>Detail Konfirmasi</Typography>
                    <div className="grid grid-2x gap-20px" style={{ padding: 20, paddingRight: 40, paddingLeft: 40 }}>
                        <div className="column-1" style={{ width: '90%' }}>
                            <div>
                                <Autocomplete
                                    options={listJenis}
                                    getOptionLabel={(option) => option.value}
                                    disableClearable
                                    style={{ width: '100%' }}
                                    onChange={(event, newInputValue) => {
                                        setJenis(newInputValue)
                                        forceUpdate()
                                    }}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                            InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                            label={'Jenis Pesanan'}
                                        />
                                    }
                                    value={jenis}
                                />
                            </div>
                        </div>
                        <div className="column-2" style={{ width: '90%' }}>
                            <div>
                                <CustomTextField
                                    label="Unit/Kelas"
                                    onChange={(val) => {
                                        setUnitClass(val)
                                        forceUpdate()
                                    }}
                                />
                            </div>
                        </div>

                        <div className="column-1" style={{ width: '90%' }}>
                            <div>
                                <Autocomplete
                                    options={dataAmbulance}
                                    getOptionLabel={(option) => option.value}
                                    style={{ width: '100%' }}
                                    onChange={(event, newInputValue) => {
                                        setAmbulance(newInputValue)
                                        forceUpdate()
                                    }}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                            InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                            label={'Mobil Ambulance'}
                                        />
                                    }
                                    value={ambulance}
                                />
                            </div>
                        </div>

                        <div className="column-2" style={{ width: '90%' }}>
                            <div>
                                <CustomTextField
                                    value={price}
                                    label="Perkiraan Harga"
                                    InputProps={{
                                        inputComponent: NumberFormatCustom,
                                    }}
                                    onChange={(val) => {
                                        setPrice(val)
                                        forceUpdate()
                                    }}
                                />
                            </div>
                        </div>

                        <div className="column-1" style={{ width: '90%' }}>
                            <div>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardTimePicker
                                        ampm={false}
                                        required={ambulance !== null ? true : false}
                                        label="Perkiraan Jam Berangkat"
                                        error={errorJamBerangkat}
                                        helperText={texterrorJamBerangkat}
                                        value={jamBerangkat}
                                        onChange={(val) => {
                                            setJamBerangkat(val)
                                            setErrorJamBerangkat(false)
                                            setTextErrorJamBerangkat("")
                                            forceUpdate()
                                        }}
                                        style={{ width: '100%' }}
                                        inputProps={{ style: { fontSize: 14 } }}
                                        InputLabelProps={{ style: { fontSize: 14 } }}
                                    />
                                </MuiPickersUtilsProvider>
                            </div>
                        </div>
                        <div className="column-2" style={{ width: '90%' }}>
                            <div>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardTimePicker
                                        ampm={false}
                                        required={ambulance !== null ? true : false}
                                        label="Perkiraan Jam Pulang"
                                        error={errorJamPulang}
                                        helperText={texterrorJamPulang}
                                        value={jamPulang}
                                        onChange={(val) => {
                                            setJamPulang(val)
                                            setErrorJamPulang(false)
                                            setTextErrorJamPulang("")
                                            forceUpdate()
                                        }}
                                        style={{ width: '100%' }}
                                        inputProps={{ style: { fontSize: 14 } }}
                                        InputLabelProps={{ style: { fontSize: 14 } }}
                                    />
                                </MuiPickersUtilsProvider>
                            </div>
                        </div>
                        <div className="column-1" style={{ width: '90%' }}>
                            <div>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardTimePicker
                                        ampm={false}
                                        label="Jam Berangkat Actual"
                                        value={berangkatActual}
                                        onChange={setBerangkatActual}
                                        style={{ width: '100%' }}
                                        inputProps={{ style: { fontSize: 14 } }}
                                        InputLabelProps={{ style: { fontSize: 14 } }}
                                    />
                                </MuiPickersUtilsProvider>
                            </div>
                        </div>
                        <div className="column-2" style={{ width: '90%' }}>
                            <div>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardTimePicker
                                        ampm={false}
                                        label="Jam Pulang Actual"
                                        value={pulangActual}
                                        onChange={setPulangActual}
                                        style={{ width: '100%' }}
                                        inputProps={{ style: { fontSize: 14 } }}
                                        InputLabelProps={{ style: { fontSize: 14 } }}
                                    />
                                </MuiPickersUtilsProvider>
                            </div>
                        </div>

                        <div className="column-1" style={{ width: '90%' }}>
                            <div>
                                <CustomTextField
                                    label="Catatan Lainnya"
                                    onChange={(val) => {
                                        setNotes(val)
                                        forceUpdate()
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <Typography style={{ color: 'black', fontWeight: '500', marginTop: 15, fontFamily: 'Poppins' }}>Detail Petugas</Typography>
                    <div className="grid grid-2x gap-20px" style={{ padding: 20, paddingRight: 40, paddingLeft: 40 }}>
                        <div className="column-1" style={{ width: '90%' }}>
                            <div>
                                <Autocomplete
                                    multiple
                                    options={dataPerawat}
                                    getOptionLabel={(option) => option.value}
                                    disableClearable
                                    style={{ width: '100%' }}
                                    onChange={(event, newInputValue) => {
                                        setPerawat(newInputValue)
                                        // setErrorPerawat(false)
                                        // setTextErrorPerawat("")
                                        // setErrorSupir(false)
                                        // setTextErrorSupir("")
                                        forceUpdate()
                                    }}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            // required={ambulance !== null ? true : false}
                                            // helperText={texterrorPerawat}
                                            // error={errorPerawat}
                                            InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                            InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                            label={'Perawat'}
                                        />
                                    }
                                    value={perawat}
                                />
                            </div>
                        </div>
                        <div className="column-2" style={{ width: '90%' }}>
                            <Autocomplete
                                options={dataSupir}
                                getOptionLabel={(option) => option.value}
                                disableClearable
                                style={{ width: '100%' }}
                                onChange={(event, newInputValue) => {
                                    setSupir(newInputValue)
                                    // setErrorSupir(false)
                                    // setTextErrorSupir("")
                                    // setErrorPerawat(false)
                                    // setTextErrorPerawat("")
                                    forceUpdate()
                                }}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        // required={ambulance !== null ? true : false}
                                        // helperText={texterrorSupir}
                                        // error={errorSupir}
                                        InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                        InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                        label={'Supir'}
                                    />
                                }
                                value={supir}
                            />
                        </div>
                        <div className="column-1" style={{ width: '90%' }}>
                            <div>
                                <Autocomplete
                                    multiple
                                    options={dataDokter}
                                    getOptionLabel={(option) => option.value}
                                    disableClearable
                                    style={{ width: '100%' }}
                                    onChange={(event, newInputValue) => {
                                        setDokter(newInputValue)
                                        // setErrorDokter(false)
                                        // setTextErrorDokter("")
                                        forceUpdate()
                                    }}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                            InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                            label={'Dokter'}
                                            // required={ambulance !== null ? true : false}
                                            // helperText={texterrorDokter}
                                            // error={errorDokter}
                                        />
                                    }
                                    value={dokter}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}>
                <div
                    style={{ backgroundColor: '#2a9c6c', width: 120, borderRadius: 20, padding: 5, display: 'flex', justifyContent: 'center', cursor: 'pointer' }}
                    onClick={() => {
                        handleSave()
                        // console.log(content);
                        // console.log(String(content).indexOf("*"));
                    }}>
                    <Typography style={{ color: 'white' }}>Simpan</Typography>
                </div>
            </div>

            {visibleMap && (
                <LoadScript googleMapsApiKey={Constant.API_KEY_GOOGLE} libraries={lib}>
                    <Map
                        onClose={() => setvisibleMap(false)}
                        setSaveDataMap={(val) => {
                            setErrorAlamat(false)
                            setTextErrorAlamat("")
                            setSaveDataMap(val)
                            setvisibleMap(false)
                            console.log(val);
                        }}
                        saveDataMap={saveDataMap}
                    />
                </LoadScript>
            )}
        </div>
    )
}